import { render, staticRenderFns } from "./MontageGasIcon.vue?vue&type=template&id=3b87e018&scoped=true"
import script from "./MontageGasIcon.vue?vue&type=script&lang=js"
export * from "./MontageGasIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b87e018",
  null
  
)

export default component.exports